module.exports = __webpack_public_path__ + "static/media/logo.7267c266.svg";